import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const EchoPlugin = {
    install(app) {
        // Export Pusher to the window (Echo requires this)
        window.Pusher = Pusher;
        // Set up the Echo instance and attach it to the app's global properties
        app.config.globalProperties.$echo = new Echo({
            broadcaster: 'pusher',
            key: import.meta.env.VITE_APP_PUSHER_APP_KEY,
            cluster: import.meta.env.VITE_APP_PUSHER_CLUSTER,
        });
    },
};

export default EchoPlugin;
